const initialState = {
  selectedItem: null,
};

const vehicles = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_VEHICLES':
      return {
        ...state,
        selectedItem: action.data,
      };

    default:
      return state;
  }
};
export default vehicles;
